let $ = require( "jquery" );

$(function() {

    let footerNavToggles = $('.footer-menu-column h2');

    footerNavToggles.on('click', function() {
        if($(window).width() > 768) return;

        let submenu = $(this).siblings('ul'),
            otherSubmenus = $('.footer-menu-column ul').not(submenu).not('.social-media-menu');

        if(submenu.length) {
            submenu.slideToggle();
            $(this).toggleClass('menu-open');

            otherSubmenus.slideUp();
            otherSubmenus.siblings('h2').removeClass('menu-open');
        }
    });

});

